<template>
  <div class="index">
    <div class="header carousel_one">
      <div class="carousel_height">
        <div class="left_indicate" @mouseleave="leave()">
          <div :class="isShow?'left_indicate_content_hover':'left_indicate_content'">
            <div class="mb24" v-for="(item,index) in categoryList.list" :key="index">

              <router-link v-if="!!item" class="c-white" :title="item.subject_name"
                           :to="{name:'e_book_index_category_search',
                             query:{ebook_subject_id: item.id}}">
                <i class="el-icon-location-outline"></i> {{item.subject_name}}
              </router-link>
            </div>
          </div>
          <div class="mb24 more c-white" @mouseenter="enter">
            <i v-if="!isShow" class="el-icon-location-outline"></i> 更多
          </div>
        </div>
        <div class="carousel">
          <el-carousel v-if="get(adminSettingDetailList.list,'[0].elements[0].value')" :interval="5000" trigger="click" height="485px">
            <el-carousel-item v-for="(item,index) in get(adminSettingDetailList.list,'[0].elements[0].value')"
                              :key="index">
              <img v-lazy="item.name" :key="item.name" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="classify_content">
      <div class="content_center">
        <div class="cut_wire"></div>
        <p class="classify_content_title">推荐图书<span class="fr fz16 pt14" @click="routeCategory">更多</span></p>
        <div class="management_card">
          <router-link v-for="(item,index) in (isArray(recommendBook)&&recommendBook.length>0&&recommendBook)"
                       :key="index" :to="{name:'e_book_detail',query:{ebook_id: item.id}}">
            <div class="recommend_card bgc-fff" v-if="!!item">
              <img class="card_img" v-lazy="item.picture" :key="item.picture" alt="">
              <div v-if="+item.is_sale === 1" class="card_time">
                折扣剩余时间:{{item.end_discount_at | secondToDate(formatMyDate)}}
              </div>
              <p class="course_name" :title="item.ebook_name">{{item.ebook_name}}</p>
              <p class="author_name">{{item.author_name}}</p>
              <p>
                <span class="free" :class="{'price':+item.ebook_price>0}">
                  {{item.ebook_price|discount(item.is_sale,item.ebook_discount)}}
                </span>
                <span v-if="isDiscountPast(item)" class="history_price">{{item.ebook_price}}</span>
              </p>
              <div class="card_tag">
                <el-tag class="ml5" size="mini" v-for="(item1, index1) in item.tag" :key="index1">{{item1.tag_name}}
                </el-tag>
                <el-tag class="ml5" size="mini" v-if="item.course">课程</el-tag>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="content_img">
      <img v-if="get(adminSettingDetailList.list,'[1].elements[0].value[0].name')"
           v-lazy="get(adminSettingDetailList.list,'[1].elements[0].value[0].name')">
    </div>
    <div class="course_content graduate">
      <div class="content_center">
        <div class="cut_wire"></div>
        <p class="classify_content_title">{{get(listObject,'yjc.type_name')}}<span class="fr fz16 pt14" @click="routeCategory">更多</span></p>
        <div class="course_content_img graduate_img">
          <img class="course_content_img_left" v-if="get(adminSettingDetailList.list,'[2].elements[0].value[0].name')"
               v-lazy="get(adminSettingDetailList.list,'[2].elements[0].value[0].name')"
               :key="get(adminSettingDetailList.list,'[2].elements[0].value[0].name')">
        </div>
        <div class="course_content_right">
          <router-link v-for="(item,index) in (isArray(regularList)&&regularList.length>0&&regularList)"
                       :key="index" :to="{name:'e_book_detail',query:{ebook_id: item.id}}">
            <div class="card bgc-fff" v-if="!!item">
              <img class="card_img" v-lazy="item.picture" :key="item.picture" alt="">
              <div v-if="+item.is_sale === 1" class="card_time">
                折扣剩余时间: {{item.end_discount_at | secondToDate(formatMyDate)}}
              </div>
              <p class="course_name" :title="item.ebook_name">{{item.ebook_name}}</p>
              <p class="author_name">{{item.author_name}}</p>
              <p>
                <span class="free" :class="{'price':+item.ebook_price>0}">
                   {{item.ebook_price|discount(item.is_sale,item.ebook_discount)}}
                </span>
                <!--                <span v-if="+item.ebook_discount!==1" class="history_price">{{item.ebook_price}}</span>-->
                <span v-if="isDiscountPast(item)" class="history_price">{{item.ebook_price}}</span>
              </p>
              <div class="card_tag">
                <el-tag class="ml5" size="mini" v-for="(item1, index1) in item.tag" :key="index1">{{item1.tag_name}}
                </el-tag>
                <el-tag class="ml5" size="mini" v-if="item.course">课程</el-tag>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="course_content vocational">
      <div class="content_center">
        <div class="cut_wire"></div>
        <p class="classify_content_title">{{get(listObject,'gz.type_name')}}<span class="fr fz16 pt14" @click="routeCategory">更多</span></p>
        <div class="course_content_img vocational_img">
          <img class="course_content_img_left" v-if="get(adminSettingDetailList.list,'[2].elements[0].value[1].name')"
               v-lazy="get(adminSettingDetailList.list,'[2].elements[0].value[1].name')"
               :key="get(adminSettingDetailList.list,'[2].elements[0].value[1].name')">
        </div>
        <div class="course_content_right">
          <router-link
            v-for="(item,index) in (isArray(professionalList) && professionalList.length>0 && professionalList)"
            :key="index" :to="{name:'e_book_detail',query:{ebook_id: item.id}}">
            <div class="card bgc-fff" v-if="!!item">
              <img class="card_img" v-lazy="item.picture" :key="item.picture" alt="">
              <div v-if="+item.is_sale === 1" class="card_time">
                折扣剩余时间: {{item.end_discount_at | secondToDate(formatMyDate)}}
              </div>
              <p class="course_name" :title="item.ebook_name">{{item.ebook_name}}</p>
              <p class="author_name">{{item.author_name}}</p>
              <p>
                <span class="free" :class="{'price':+item.ebook_price>0}">
                  {{item.ebook_price|discount(item.is_sale,item.ebook_discount)}}
                </span>
                <span v-if="isDiscountPast(item)" class="history_price">{{item.ebook_price}}</span>
              </p>
              <div class="card_tag">
                <el-tag class="ml5" size="mini" v-for="(item1, index1) in item.tag" :key="index1">{{item1.tag_name}}
                </el-tag>
                <el-tag class="ml5" size="mini" v-if="item.course">课程</el-tag>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CDate from 'src/class/CDate'
  import {
    isArray,
    get,
    each
  } from 'lodash'
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  export default {
    data() {
      return {
        formatMyDate: '',
        isShow: false,
        imgList: [
          {
            url: require('../../../../../src/assets/img/ebook_index_one.jpg')
          },
          {
            url: require('../../../../../src/assets/img/ebook_index_tow.jpg')
          },
          {
            url: require('../../../../../src/assets/img/ebook_index_three.jpg')
          },
          {
            url: require('../../../../../src/assets/img/ebook_index_four.jpg')
          },
          {
            url: require('../../../../../src/assets/img/ebook_index_five.jpg')
          },
        ],
        regularList: [],//研究生
        regularListLFirst: null,//研究生
        professionalList: [],//高职业
        professionalFirst: null,//高职业
        recommendBook: [],
        listObject: {},
      };
    },
    filters: {
      discount(price, sale, discount) {
        if (+price > 0) {
          return +sale === 0 ? +price : (+price * +discount).toFixed(2)
        } else {
          return '免费'
        }
      },
      price(discount, price) {
        let result = discount * price;
        if (isNaN(result)) {
          return '--';
        }
        return result.toFixed(2)
      },
      secondToDate(end_discount_at, currentData) {
        if (!(end_discount_at && currentData)) {
          return '';
        }
        let newDate = CDate.diff(end_discount_at, currentData, 'msd');
        if (newDate > 0) {
          let time = newDate;
          if (null != time && "" != time) {
            if (time > 60 && time < 60 * 60) {
              time = parseInt(time / 60.0) + "分" + parseInt((parseFloat(time / 60.0) -
                parseInt(time / 60.0)) * 60) + "秒";
            } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
              time = parseInt(time / 3600.0) + "时" + parseInt((parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) * 60) + "分" +
                parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                  parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
            } else if (time >= 60 * 60 * 24) {
              time = parseInt(time / 3600.0 / 24) + "天" + parseInt((parseFloat(time / 3600.0 / 24) -
                parseInt(time / 3600.0 / 24)) * 24) + "时" + parseInt((parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) * 60) + "分" +
                parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
            } else {
              time = parseInt(time) + "秒";
            }
          }
          return time;
        }
        return 0
      },

    },
    computed: {
      ...mapGetters({
        'ebookIndexList': 'getPublicEBookIndexListData',//列表
        'categoryList': 'getCategoryList',//科目分类列表
        'getEbookTypeList': 'getTypeList',//图书类型列表
        'adminSettingDetailList': 'getPublisherPictureSetList',//图片列表

      }),
      isDiscountPast() {
        return function (item) {
          if (+item.ebook_discount !== 1) {
            return new CDate(item.end_discount_at).getTime() > CDate.getServerDate().getTime()
          }
          return false
        }
      },
    },

    methods: {
      ...mapActions({
        'functionPublicEBookIndexListDataPort': 'actionPublicEBookIndexListDataPort',//列表
        'functionEBookCategoryListPort': 'actionEBookSubjectListPort',//电子书科目分类列表
        'actionEbookTypeList': 'actionEBookGetTypeListPort',//图书类型列表
        'functionAdminSettingDetailList': 'actionAdminSettingDetailListPort',//图片列表
      }),
      routeCategory() {
        this.$router.push({
          name: 'e_book_index_category_search',
        })
      },
      get,
      isArray,
      timeOut() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          let myDate = CDate.getServerDate().__date;
          this.formatMyDate = CDate.format(myDate, 'yyyy-MM-dd HH:mm:ss');
        }, 900)
      },
      enter() {
        this.categoryList.total > 8 ? this.isShow = true : this.isShow = false;
      },
      leave() {
        this.isShow = false;
      },
      initData() {
        this.functionEBookCategoryListPort({size: 999});
        this.functionPublicEBookIndexListDataPort({ebook_tag_id: 3}).then((result) => {
          this.recommendBook = result.list;
        });
        this.functionPublicEBookIndexListDataPort({ebook_type_id: 1, ebook_tag_id: [1]}).then((result) => {
          /*this.regularListLFirst = first(result.list);
          this.regularList = drop(result.list);*/
          this.regularList = result.list
        });
        this.functionPublicEBookIndexListDataPort({ebook_type_id: 2, ebook_tag_id: [1]}).then((result) => {
          /*this.professionalFirst = first(result.list);
          this.professionalList = drop(result.list);*/
          this.professionalList = result.list
        });
        this.actionEbookTypeList({tag_type: 2, page: 1, size: 15}).then((result) => {
          each(result.list, item => {
            if (item.id === 1) {
              this.listObject['yjc'] = item;
            } else if (item.id === 2) {
              this.listObject['gz'] = item;
            }
          })
        })
      },
    },
    beforeDestroy() {
      clearInterval(this.timer); //关闭定时刷新
    },
    created() {
      this.initData();
      this.timeOut();
      this.functionAdminSettingDetailList();
    }
  }

</script>

<style lang="scss" scoped>
  .index {
    width: 100%;
    background-color: white !important;
    overflow: hidden;
  }

  .el-carousel__item img {
    width: 100%;
    height: 100%;
  }

  .carousel_height {
    height: 485px;
    width: 1280px;
    margin: 0 auto;
    position: relative;
  }

  .header {
    width: 100%;
    height: 485px;
  }

  .carousel_one {
    background-color: #CACCD1;
  }

  .left_indicate {
    width: 184px;
    height: 485px;
    background-color: #CACCD1;
    position: absolute;
    top: 0;
    left: 0;
  }

  .left_indicate_content {
    margin-top: 45px;
    max-height: 360px;
    background-color: #CACCD1;
    position: relative;
    z-index: 4;
    padding-left: 50px;
    overflow: hidden;
    transition: all 0.6s;
  }

  .left_indicate_content_hover {
    height: auto;
    margin-top: 45px;
    background-color: #CACCD1;
    position: relative;
    z-index: 4;
    padding-left: 50px;
    overflow: hidden;
    transition: all 0.6s;
  }

  .more {
    margin: 10px 0 0 50px;
  }

  .carousel {
    width: 1096px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .c-white {
    display: inline-block;
    width: 120px;
    color: white;
    font-size: 14px;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .classify_content {
    width: 100%;
    height: 419px;
    background-color: #30C39E;
  }

  .content_center {
    padding-left: 20px;
    padding-right: 20px;
    width: 1280px;
    margin: 0 auto;
    position: relative;
  }

  .classify_content_title {
    width: 100%;
    height: 50px;
    font-family: PingFangSC;
    font-size: 36px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #141414;
    margin-top: 40px;
    margin-bottom: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .management_card {
    width: 1350px;
    height: 270px;
    overflow: hidden;
  }

  .cut_wire {
    width: 100%;
    height: 1px;
  }

  .recommend_card {
    width: 233px;
    height: 262px;
    display: inline-block;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    overflow: hidden;
    position: relative;
    margin-bottom: 10px;
    margin-right: 15px;
  }

  .card {
    width: 233px;
    height: 262px;
    display: inline-block;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    overflow: hidden;
    position: relative;
    margin-bottom: 10px;
    margin-right: 19px;
  }

  .card_img {
    transform: scale(1);
    transition: all 0.6s;
    width: 100%;
    height: 135px;
    display: block;
  }

  .card_img:hover {
    transform: scale(1.2);
    transition: all 0.6s;
  }

  .card_time {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: white;
    width: 200px;
    height: 16px;
    background-color: rgba(255, 89, 38, 0.9);
    font-size: 12px;
    text-align: center;
    position: absolute;
    right: 15px;
    top: 120px;
    border-radius: 3px;
  }

  .card_hot {
    width: 30px;
    height: 18px;
    border: 1px solid pink;
    font-size: 11px;
    text-align: center;
    line-height: 18px;
    color: pink;
    border-radius: 2px;
    display: inline-block;
  }

  .card_new {
    width: 30px;
    height: 18px;
    border: 1px solid rgba(0, 54, 255, 0.4);
    font-size: 11px;
    text-align: center;
    line-height: 18px;
    border-radius: 2px;
    color: rgba(0, 54, 255, 0.4);
    display: inline-block;
  }

  .card_recommend {
    width: 30px;
    height: 18px;
    border-radius: 2px;
    border: 1px solid #007513;
    font-size: 11px;
    text-align: center;
    line-height: 18px;
    color: #007513;
    display: inline-block;
  }

  .course_name {
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    font-size: 16px;
    text-overflow: ellipsis;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: PingFangSC;
    margin: 12px 0 0 12px;
  }

  .author_name {
    width: 90%;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 6px 0 0 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    opacity: 0.5;
    color: #000000;
    font-family: PingFangSC;
  }

  .free {
    display: inline-block;
    margin: 6px 0 0 12px;
    font-family: PingFangSC;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #0dbb52;
  }

  .price {
    color: #ff5926 !important;
  }

  .history_price {
    text-decoration: line-through;
    display: inline-block;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-left: 15px;
    font-size: 12px;
    color: #a0a0a0;
  }

  .card_tag {
    margin: 8px 0 0 12px;
  }

  .content_img {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .course_content {
    width: 100%;
    height: 690px;
    position: relative;
  }

  .course_content_img {
    width: 225px;
    height: 533px;
    position: absolute;
    left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .course_content_img_left {
    width: 225px;
    height: 533px;
  }

  .course_content_right {
    width: 1250px;
    height: 545px;
    position: absolute;
    right: 0;
    left: 260px;
    overflow: hidden;
  }

  .graduate {
    background-color: #8DB9CA;
  }

  .vocational {
    background-color: #FFC845;
  }

  .graduate_img {
    background-color: #8DB9CA;
  }

  .vocational_img {
    background-color: #FFC845;
  }
</style>
